// extracted by mini-css-extract-plugin
module.exports = {"label":"_82a84cf"};